import api from './api';

const professionalAccessService = {
  async getAccessList(professionalId) {
    const response = await api.get(`/professionals/${professionalId}/access`);
    return response.data;
  },

  async grantAccess(professionalId, dto) {
    const response = await api.post(`/professionals/${professionalId}/access`, dto);
    return response.data;
  },

  async updateAccess(professionalId, userId, dto) {
    const response = await api.put(`/professionals/${professionalId}/access/${userId}`, dto);
    return response.data;
  },

  async revokeAccess(professionalId, userId) {
    await api.delete(`/professionals/${professionalId}/access/${userId}`);
    return null;
  },
};

export default professionalAccessService;
